// redux/actions/AUTORIDADES/types.js
export const FETCH_AUTORIDADES_SUCCESS = "FETCH_AUTORIDADES_SUCCESS";
export const FETCH_AUTORIDADES_FAILURE = "FETCH_AUTORIDADES_FAILURE";
